import { render, staticRenderFns } from "./CompositeBilling.vue?vue&type=template&id=3c774156&scoped=true&"
import script from "./CompositeBilling.vue?vue&type=script&lang=js&"
export * from "./CompositeBilling.vue?vue&type=script&lang=js&"
import style0 from "./CompositeBilling.vue?vue&type=style&index=0&id=3c774156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c774156",
  null
  
)

export default component.exports